import React, { useEffect, useState } from "react";
import "react-day-picker/dist/style.css";
import { HiOutlineTicket } from "react-icons/hi";
import { Assort } from "../../../models/Assort";
import { TicketAccess } from "../../../models/TicketAccess";
import useBasketManager from "../../SaleMovie/CinemaHall/hooks/useBasketManager";
import usePreBasket from "../../Universal/hooks/usePreBasket";
import PreBasketSummary from "../../Universal/PreBasketSummary";
import TicketLineSummary from "../../Universal/TicketLineSummary";
import "./style.scss";
import LoadingSpinner from "../../../../features/Loading/LoadingSpinner";
import { BasketItem } from "../../../models/BasketItem";
import { useTranslation } from "react-i18next";
import CalendarPassReservaton from "./calendarPassReservation";
import { Exercise } from "../../../models/Exercise";
import useFacility from "../../../../utils/hooks/useFacility";
import useCalculatePreBasketQnt from "../../Universal/hooks/useCalculatePreBasketQnt";
import { QntStateItem } from "../../../models/QntStateItem";

interface IProps {
  tickets: Assort[];
  ticketAccess: TicketAccess;
  ticketLimit: number;
  refreshCapacityAfterAddTicket: () => void;
  exerciseDetails?: Exercise;
  joinToExerciseByPass: (exerciseIds: string, assignType: boolean, passId: number) => void;
  alertCalendar: string;
}
const CalendarAssorts: React.FC<IProps> = ({
  tickets,
  ticketLimit,
  ticketAccess,
  refreshCapacityAfterAddTicket,
  joinToExerciseByPass,
  exerciseDetails,
  alertCalendar,
}: IProps) => {
  const { t } = useTranslation();
  const { preBasket, addItemToBasket, removeItemFromBasket, clearBasket } = usePreBasket();
  const { getBasket } = useBasketManager();
  const [allowToAssign, setAllowToAssign] = useState(false);
  const facilityIds = useFacility();
  const { qntState } = useCalculatePreBasketQnt(preBasket);
  const handleDeleteBasket = () => {
    clearBasket();

    setTimeout(() => {
      getBasket();
    }, 200);
    setTimeout(() => {
      refreshCapacityAfterAddTicket();
    }, 300);
  };
  const ticketsInCurrentBasket = () => {
    if (qntState && qntState.length > 0) {
      return qntState
        .filter((item) => item.exerciseIds === ticketAccess.exerciseIds)
        .reduce((acc: number, item: QntStateItem) => acc + item.count, 0);
    } else {
      return preBasket.reduce((acc: number, item: BasketItem) => acc + item.qnt, 0);
    }
  };

  const asignByPass = (assigned: boolean, passId: number) => {
    joinToExerciseByPass(ticketAccess.exerciseIds, assigned, passId);
  };

  useEffect(() => {
    if (facilityIds === "1212") {
      setAllowToAssign(true);
    }
  }, [facilityIds]);

  return (
    <React.Fragment>
      {tickets.length > 0 ? (
        <React.Fragment>
          {tickets.map((item, index) => (
            <div className={"calendar-sale-ticket"} key={index}>
              <TicketLineSummary
                item={item}
                exercise={ticketAccess}
                preBasket={preBasket}
                addItemToBasket={addItemToBasket}
                removeItemFromBasket={removeItemFromBasket}
                ticketLimit={ticketLimit}
                qntState={qntState}
              />
            </div>
          ))}

          {ticketLimit === ticketsInCurrentBasket() && (
            <div className="flex-between-center alert alert-red ">
              <b>{t("nie_mozesz_dodac_wiekszej_ilosci_biletow_do_koszyka")}</b>
            </div>
          )}
          {exerciseDetails && (
            <React.Fragment>
              {" "}
              {allowToAssign && (
                <CalendarPassReservaton
                  exerciseDetails={exerciseDetails}
                  asignByPass={asignByPass}
                  alertCalendar={alertCalendar}
                />
              )}
            </React.Fragment>
          )}

          <div className="flex-between-center alert alert-second ">
            <b>
              {t("na_to_wejscie_obowiazuje_limit_biletow_pozostalo")}
              {ticketLimit! > 0 ? (
                <React.Fragment>{ticketLimit - ticketsInCurrentBasket()}</React.Fragment>
              ) : (
                <React.Fragment>0</React.Fragment>
              )}{" "}
              {t("biletow")}{" "}
            </b>
            <HiOutlineTicket className="alert-icon" />
          </div>
        </React.Fragment>
      ) : (
        <div style={{ marginBottom: "20px", marginTop: "20px" }}>
          <LoadingSpinner />
        </div>
      )}






      {/* <PreBasketSummary ticketLimit={ticketLimit} preBasket={preBasket} clearBasket={handleDeleteBasket} /> */}
      <PreBasketSummary
        ticketLimit={ticketLimit}
        preBasket={preBasket}
        clearBasket={handleDeleteBasket}
        qntState={qntState}
      />
    </React.Fragment>
  );
};

export default CalendarAssorts;
